/**
 * 项目回款实体
 */

import { useState, useEffect } from 'react';

import {
    ConfigProvider,
    Modal,
    Row,
    Col,
    message,
    InputNumber,
    DatePicker,
    Input,
    Image,
    Upload,
} from 'antd';
import $ from 'jquery';
import { PlusOutlined } from '@ant-design/icons';
import {
    locale,
    AddRequestHeaders,
    rff,
    uploadImageButton,
    GetBase64,
    UjoinParams,
    uuid,
    AliyunOSSclient,
    AliyunOSSDelete,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dateLocale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState(0);
    const [date, setDate] = useState(currentDate);
    const [payerName, setPayerName] = useState('');
    const [payerAccount, setPayerAccount] = useState('');
    const [beneficiaryName, setBeneficiaryName] = useState('');
    const [beneficiaryAccount, setBeneficiaryAccount] = useState('');
    const [personnel, setPersonnel] = useState('');
    const [description, setDescription] = useState('');

    const [fileList, setFileList] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [deleteFileList, setDeleteFileList] = useState([]);

    const quit = () => {
        setOpen(false);
        setLoading(false);
        setAmount(0);
        setDate(currentDate);
        setPayerName('');
        setPayerAccount('');
        setBeneficiaryName('');
        setBeneficiaryAccount('');
        setPersonnel('');
        setDescription('');

        setFileList([]);
        setPreviewOpen(false);
        setPreviewImage('');
        setDeleteFileList([]);
    }

    const cancel = () => {
        quit();
        if (props.record.action === 'CREATE') {
            // 新增情况下取消, 则删除已上传的图片
            aliyunOSSDeleteFileList(fileList);
            aliyunOSSDeleteFileList(deleteFileList);
        } else {
            // 修改取消情况下, 删除新增已上传的文件
            if (props.record && props.record.image_uri && fileList.length > 0) {
                let imageUris = props.record.image_uri.split(',');
                for (let i = 0; i < fileList.length; i++) {
                    let item = fileList[i];
                    if (imageUris.indexOf(item.path) === -1) {
                        AliyunOSSDelete(item);
                    }
                }
            }
        }
    };

    useEffect(() => {
        // 修改初始化
        if (props.record && props.action === CNF.actionName.UPDATE) {
            setAmount(props.record.amount > 0 ? props.record.amount : 0);
            setDate(props.record.date ? props.record.date : currentDate);
            setPayerName(props.record.payer_name);
            setPayerAccount(props.record.payer_account);
            setBeneficiaryName(props.record.beneficiary_name);
            setBeneficiaryAccount(props.record.beneficiary_account);
            setPersonnel(props.record.personnel);
            setDescription(props.record.description);
            if (props.record.image_uri) {
                // 获取图片
                var params = {
                    'acl': 'GetObject'
                }
                let _fileList = [];
                $.ajax({
                    url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                    headers: AddRequestHeaders(),
                    type: 'GET', success: function (data) {
                        if (data.res === 0) {
                            const token = data.dat;
                            let imageUris = props.record.image_uri.split(',');
                            for (let i = 0; i < imageUris.length; i++) {
                                let item = imageUris[i];
                                try {
                                    //  去掉路径‘/’
                                    let result = AliyunOSSclient(token).signatureUrl(item, {
                                        expires: 3600,
                                        response: {
                                            'content-disposition': 'attachment; filename="' + item.split('/').pop() + '"'
                                        }
                                    });
                                    _fileList.push({
                                        url: result,
                                        preview: result,
                                        status: 'done',
                                        percent: 100,
                                        path: item,
                                        uid: i + 1,
                                    });

                                } catch (e) {
                                    console.log(e);
                                }
                            }
                            setFileList(_fileList);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                });
            }
        }
    }, [props.record, props.action, messageApi]);

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, acl = 'private') => {
        const headers = {
            // 文件acl授权类型
            'x-oss-object-acl': acl
        }
        var params = {
            'acl': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    try {
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            // 路径由以下部分组成
                            // 项目代码+repayments+组织前缀+uuid+附件名（去除空格）
                            let path = CNF.projectCode.toLowerCase();
                            path += '/repayments';
                            path += '/' + props.preGroup;
                            path += '/' + uuid;
                            path += '/' + file.name.replace(/\s/g, '');
                            // 获取最新的文件列表
                            let newFileList = [...fileList];
                            AliyunOSSclient(token).multipartUpload(path, file,
                                {
                                    // 请求头
                                    headers,
                                    // 获取分片上传进度、断点和返回值
                                    progress: (p) => {
                                        setFileList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length - 1] = {
                                                ...newItems[newItems.length - 1],
                                                percent: parseInt(p * 100),
                                                status: p === 1 ? 'done' : 'uploading',
                                                url: CNF.ossApi + path,
                                                path: path,
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    },
                                    // 分片数量
                                    parallel: Math.ceil(file.size / 1024 / 1024),
                                    // 设置分片大小, 默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    // 上传成功
                                    if (result.res.status === 200) { }
                                }).catch((e) => {
                                    // 上传失败
                                    messageApi.error(file.name + ' 上传失败！', CNF.messageDuration);
                                    setFileList(newFileList.pop());
                                });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
        return false
    }

    /**
     * 删除图片列表
     * @param {*} deleteFileArr 
     */
    const aliyunOSSDeleteFileList = (deleteFileArr) => {
        for (let file of deleteFileArr) {
            //  从阿里云上删除
            AliyunOSSDelete(file);
        }
        setDeleteFileList([]);
    }

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const handlePreview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                // 转换图片, 用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 52428800) {
            messageApi.error('上传图片超过5M, 建议压缩图片! ', CNF.messageDuration);
            return false;
        }
        return true;
    }

    const ok = () => {
        //  参数校验
        if (!amount) {
            messageApi.error('回款金额不能为零!', CNF.messageDuration);
            return false;
        }
        if (!payerName) {
            messageApi.error('付款方户名不能为空!', CNF.messageDuration);
            return false;
        }
        if (!beneficiaryName) {
            messageApi.error('收款方户名不能为空!', CNF.messageDuration);
            return false;
        }
        if (!personnel) {
            messageApi.error('回款人员不能为空', CNF.messageDuration);
            return false;
        }

        // 多张图片用英文逗号隔开
        let imageUri = '';
        for (let i = 0; i < fileList.length; i++) {
            let file = fileList[i];
            if (i === 0) {
                imageUri += file.path;
            } else {
                imageUri += ',' + file.path;
            }
        }

        setLoading(true);

        let data = {
            'date': date,
            'amount': amount,
            'payer_name': payerName,
            'payer_account': payerAccount,
            'beneficiary_name': beneficiaryName,
            'beneficiary_account': beneficiaryAccount,
            'personnel': personnel,
            'image_uri': imageUri,
            'description': description,
        }
        if (props.action === CNF.actionName.CREATE) {
            data.action = CNF.actionName.REPAYMENT;
        }

        // 执行操作
        $.ajax({
            url: CNF.api + 'project/' + (props.action === CNF.actionName.CREATE ? 'details' : 'repayments') + '/' + props.record.key,
            headers: AddRequestHeaders(),
            type: props.action === CNF.actionName.CREATE ? 'PATCH' : 'PUT',
            dataType: 'JSON',
            data: JSON.stringify(data),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                aliyunOSSDeleteFileList(deleteFileList);     // 同步删除阿里云文件
                setTimeout(function () {
                    quit();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={props.record.name ? props.record.name : props.record.project_name ? props.record.project_name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                closable={false}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}回款金额</Col>
                    <Col span={11} offset={2}>{rff}回款日期</Col>
                    <Col span={11}>
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            min={0}
                            step='0.01'
                            onChange={(value) => setAmount(value)}
                            value={amount}
                            disabled={props.action === CNF.actionName.UPDATE ? true : loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder='请选择日期'
                            onChange={(_, dateString) => setDate(dateString)}
                            value={dayjs(date, 'YYYY-MM-DD')}
                            locale={dateLocale}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}付款方户名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPayerName(e.target.value)}
                            value={payerName}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>付款方账户</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPayerAccount(e.target.value)}
                            value={payerAccount}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}收款方户名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setBeneficiaryName(e.target.value)}
                            value={beneficiaryName}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>收款方账户</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setBeneficiaryAccount(e.target.value)}
                            value={beneficiaryAccount}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}回款人</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPersonnel(e.target.value)}
                            value={personnel}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                            maxLength={255}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>
                        <Upload
                            beforeUpload={beforeUpload}
                            name='file'
                            listType='picture-card'
                            icon={<PlusOutlined />}
                            customRequest={(option) => { aliyunOSSUpload(option.file); }}
                            fileList={fileList}
                            onPreview={handlePreview}
                            disabled={loading}
                            onChange={({ fileList: newFileList }) => {
                                setFileList(newFileList);
                            }}
                            onRemove={(file) => {
                                let _deleteFileList = deleteFileList;
                                _deleteFileList.push(file);
                                setDeleteFileList(_deleteFileList);
                            }}
                        >
                            {fileList.length >= 3 ? null : uploadImageButton}
                        </Upload>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default Entity